/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Modal } from "antd";
import Main from "../layout/Main";
import { Authenticate } from "../../service/Authenticate.service";
import { store } from "../../store/store";
import { Provider } from "react-redux";
import { LoadingProvider } from "../../store/context/loading-context";
import { AxiosInterceptor } from "../layout/AxiosInterceptor";

const authService = Authenticate();

const PrivateRoute = ({ allowdRole, mode = "manage" }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isAuth, setIsAuth] = useState(true);

  const authCheck = () => {
    const payload = { role: "admin" };
    const exp = authService.isExpireToken(() => {
      authService.setCurrent(location.pathname);
      navigate("/login", { replace: true });
    });

    // ต้องคืนค่า boolean เท่านั้น  ของเดิมคืน object ของ Modal ทำให้ค่านี้ truthy เสมอ
    return !!(allowdRole.includes(payload?.role) && exp);
  };

  useEffect(() => {
    const ath = authCheck();
    setIsAuth(ath);

    if (!ath) {
      Modal.error({
        title: "Session Expire",
        content: "your session expired please relogin",
        onOk: () => {
          authService.setCurrent(location.pathname);
          navigate("/", { replace: true });
        },
      });
    }
  }, [location.pathname]);

  // สำคัญ: ห้ามประกาศ component ย่อยไว้ในตัว render (ของเดิมคือ const Contents = () => ...)
  // เพราะ React จะมองเป็น component type ใหม่ทุกครั้งที่ re-render
  // แล้ว unmount/mount ทั้ง subtree (Main -> LoadingProvider -> AxiosInterceptor -> หน้าเพจ) ใหม่หมด
  // ผลคือจอกะพริบ/ขาว และ state ของหน้าหายทุกครั้งที่เปลี่ยนหน้า
  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (mode === "print") {
    return (
      <LoadingProvider>
        <AxiosInterceptor>
          <div style={{ height: "100vh", overflow: "auto" }}>
            <Outlet />
          </div>
        </AxiosInterceptor>
      </LoadingProvider>
    );
  }

  return (
    <Provider store={store}>
      <Main>
        <Outlet />
      </Main>
    </Provider>
  );
};

export default PrivateRoute;
